export default {
    fields: {
        name: {
            label: 'First and last name',
            placeholder: 'Enter first and last name',
        },
        email: {
            label: 'Email',
            placeholder: 'Enter email',
        },
        phone: {
            label: 'Phone',
            placeholder: 'Enter message',
        },
        company: {
            label: 'Company',
            placeholder: 'Enter company',
        },
        description: {
            label: 'Message',
            placeholder: 'Enter message',
        },
        title: {
            label: 'Title',
            placeholder: 'Enter title',
        },
    },
    buttons: {
        send: 'Send',
    },
    success: {
        message: 'Your question has been sent. You will get anaswer soon!@',
    },
}
